export default "__VITE_ASSET__BEffhpgU__"